import { Suspense } from 'react'
import { Route, Routes } from 'react-router-dom'

import { LoadingIndicator, ProtectedRoute } from '@leanpay/ui'

import { useAppStore } from './app-context'
import { lazyWithRetry } from 'library/lazy-with-retry'

// Lazy load all route components for code splitting
const ChooseLogin = lazyWithRetry(() => import('./choose-login/choose-login'))
const EmailLogin = lazyWithRetry(() => import('./email-login/email-login'))
const Login = lazyWithRetry(() => import('./login/login'))
const RequestOtp = lazyWithRetry(() => import('./request-otp/request-otp'))
const ConfirmVerification = lazyWithRetry(
    () => import('./verification-process/confirm-verification'),
)
const InitVerificationForm = lazyWithRetry(
    () => import('./verification-process/init-verification-form'),
)
const VerificationStatus = lazyWithRetry(() => import('./verification-process/verification-status'))

const MainAppSLO = () => {
    const { isAuthenticated } = useAppStore()

    return (
        <Suspense fallback={<LoadingIndicator />}>
            <Routes>
                <Route path="/" element={<ChooseLogin />} />
                <Route path={'/email'} element={<EmailLogin />} />
                <Route path={'/request-otp'} element={<RequestOtp />} />
                <Route path={'/login'} element={<Login />} />

                <Route element={<ProtectedRoute isAllowed={!!isAuthenticated} redirectPath="/" />}>
                    <Route path={'/init-verification'} element={<InitVerificationForm />} />
                    <Route path={'/confirm-verification'} element={<ConfirmVerification />} />
                    <Route path={'/verification-status'} element={<VerificationStatus />} />
                </Route>
            </Routes>
        </Suspense>
    )
}

export default MainAppSLO
